<template>
  <section v-if="variants.v1 === variant"
    class="layout-pt-lg layout-pb-lg tw-px-2 lg:tw-px-0"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <LibraryPopupsVideoPopup
      v-if="vars.isPopupBool && vars.videoUrl"
      :videoUrl="vars.videoUrl"
      v-model:is-visible="isVisible"
      :portrait="vars.isVerticalBool"
    />
    <div
      class="tw-flex tw-w-full tw-max-w-[610px] tw-flex-col-reverse tw-items-center tw-gap-y-8 lg:tw-px-0 lg:tw-max-w-none lg:tw-gap-x-16 xl:tw-gap-x-24"
      :class="{ 'lg:tw-flex-row-reverse': vars.isReversedBool, 'lg:tw-flex-row': !vars.isReversedBool }"
    >
      <div class="tw-flex tw-flex-col tw-items-start tw-gap-4 lg:tw-ml-32 lg:tw-basis-[70%] xl:tw-basis-[90%]">
        <h6
  v-if="vars.altTitleText"
  style="color: var(--c-secondary) !important;"
>
  {{ vars.altTitleText }}
      </h6>


        <h2 style="color: var(--c-text-primary) !important;">{{ vars.titleText }}</h2>
        <div class="tw-mt-5 tw-flex tw-flex-col tw-gap-y-4">
          <p
            v-for="(item, index) in descriptions"
            :key="`infobox-descriptions-${index}`"
          >
            {{ item.description }}
          </p>
        </div>
        <nuxt-link
          v-if="vars.buttonLinkUrl"
          :external="true"
          :to="vars.buttonLinkUrl"
          :class="`n-${vars.buttonTypeText} n-btn tw-mt-2`"
        >
          <div class="n-btn-container">
            <div class="n-btn-group">
              <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
            </div>
          </div>
        </nuxt-link>
      </div>

      <div class="tw-w-full">
        <iframe
          v-if="!vars.isPopupBool && vars.videoUrl"
          class="tw-w-full  tw-object-cover"
          :src="vars.videoUrl"
          frameborder="0"
          allowfullscreen
          :style="vars.isVerticalBool ? 'aspect-ratio:5/8' : 'aspect-ratio:16/9'"
        ></iframe>

        <LibraryImage
          v-else-if="vars.photoImage && !vars.videoUrl"
          :src="vars.photoImage"
          :w-ratio="vars.isVerticalBool ? 9 : 645"
          :h-ratio="vars.isVerticalBool ? 16 : 430"
        />

        <div
          v-else-if="vars.photoImage && vars.videoUrl && vars.isPopupBool"
          class="tw-relative tw-w-full"
          @click="isVisible = true"
        >
          <LibraryImage
            :src="vars.photoImage"
            :alt="vars.titleText"
            image-class="tw-w-full tw-cursor-pointer "
            :w-ratio="vars.isVerticalBool ? 9 : 645"
            :h-ratio="vars.isVerticalBool ? 16 : 430"
          />
          <button class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2">
            <svg width="80" height="80" viewBox="0 0 162 162" xmlns="http://www.w3.org/2000/svg">
              <circle cx="81" cy="81" r="81" fill="white" />
              <polygon points="65,45 115,81 65,117" fill="black" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </section>





  <section v-if="variants.v2 === variant"        
         class="layout-pt-lg layout-pb-lg tw-px-2 lg:tw-px-0"        
         :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`">
           
  <div class="tw-flex tw-w-full tw-max-w-[610px] tw-flex-col-reverse tw-items-center tw-gap-y-16 lg:tw-px-0 lg:tw-max-w-none lg:tw-gap-x-8 xl:tw-gap-x-12"
       :class="{ 'lg:tw-flex-row-reverse': vars.isReversedBool, 'lg:tw-flex-row': !vars.isReversedBool }">
    
    <!-- Text Content -->
    <div class="tw-flex tw-flex-col tw-items-start tw-gap-4 lg:tw-ml-8 lg:tw-basis-[55%] xl:tw-basis-[60%]">
      <h6 v-if="vars.altTitleText" style="color: var(--c-secondary) !important;">
        {{ vars.altTitleText }}
      </h6>
      
      <h2 style="color: var(--c-text-primary) !important;">
        {{ vars.titleText }}
      </h2>
      
      <div class="tw-mt-5 tw-flex tw-flex-col tw-gap-y-4">
        <p v-for="(item, index) in descriptions" :key="`infobox-descriptions-${index}`">
          {{ item.description }}
        </p>
      </div>
      
      <nuxt-link v-if="vars.buttonLinkUrl"
                 :external="true"
                 :to="vars.buttonLinkUrl"
                 :class="`n-${vars.buttonTypeText} n-btn tw-mt-2`">
        <div class="n-btn-container">
          <div class="n-btn-group">
            <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
          </div>
        </div>
      </nuxt-link>
    </div>
    
  
    <div class="tw-relative tw-w-full tw-max-w-[350px] lg:tw-max-w-[380px] tw-pr-4 lg:tw-pr-6">
     
      <div class="tw-relative tw-w-4/5">
        <LibraryImage v-if="vars.photoImage"
                      :src="vars.photoImage"
                      :w-ratio="4"
                      :h-ratio="5" />
      </div>
      
      <div class="tw-absolute tw-top-6 tw-right-0 md:-tw-right-8 lg:-tw-right-16  tw-z-10 tw-w-4/5">
        <div class="tw-relative">
          <LibraryImage v-if="vars.thumbnailImage"
                        :src="vars.thumbnailImage"
                        :w-ratio="4"
                        :h-ratio="5" />
          <div class="tw-absolute tw-top-0 tw-left-0 tw-w-2 tw-h-full"
               style="background-color: #BFA87E;"></div>
        </div>
      </div>
    </div>
    
  </div>
</section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  mixins: [ComponentMixin],

  data() {
    return {

      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      isVisible: false,
      
    };
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    items() {
      return this.groupedVariables.items;
    },
  },

  methods: {
    isExternalLink(url: string) {
      return url.includes('http');
    },
  },
});
</script>
